export default __webpack_public_path__ + "static/media/worker10.226d6f45.jpeg";